import { definePreset, palette } from '@primeuix/themes';
import Lara from '@primeuix/themes/lara';

const primaryBrandColor = '#d6002a'; // S&P Red

export const spBrandThemePreset = definePreset(Lara, {
    semantic: {
        primary: palette(primaryBrandColor),
        formField: {
            borderColor: '#d6d6d6',
            hoverBorderColor: '#d6d6d6',
            focusBorderColor: '#d6d6d6',
            borderRadius: '0',
            color: '#333333',
            disabledBackground: '#e9ecef',
            disabledColor: '#6c757d',
            focusRing: {
                shadow: 'none'
            }
        }
    }
});